import { useQueryClient } from "react-query";
import { useContext, useState } from "react";
import { useUrlSearch } from "../../../../../../hooks/useUrlSearch";
import { ToastContext } from "../../../../../../hooks/context";
import { useApproveOrRejectPOMutation } from "../../../../../../hooks/api/mutations/useProcurement";

export const usePurchaseOrderDetails = () => {
  const queryClient = useQueryClient();
  const triggerToast = useContext(ToastContext);
  const { search, setSearch } = useUrlSearch();
  const [views, setViews] = useState({
    isAcceptDialog: false,
    isRejectDialog: false,
    isSupplier: false,
  });

  const { mutate: approveOrRejectPO, isLoading: isUpdatingStatus } =
    useApproveOrRejectPOMutation();

  const handleApproveOrRejectPO = (id, status) => {
    approveOrRejectPO(
      { id, data: { status } },
      {
        onSuccess: () => {
          const message =
            status === "ACCEPTED"
              ? "PO Approval Successful"
              : "PO Rejection Successful";
          triggerToast(message, "success");
          queryClient.invalidateQueries(["getPurchaseOrderDetails", `${id}`]);
          setViews({
            isAcceptDialog: false,
            isRejectDialog: false,
          });

          if (status === "ACCEPTED") {
            search.set("new_approved_po_id", id);
            setSearch(search, { replace: true });
          }
        },
      },
    );
  };

  const closeNewPODialog = (key) => {
    search.delete(key);
    setSearch(search, { replace: true });
  };

  return {
    isUpdatingStatus,
    views,
    search,
    setViews,
    handleApproveOrRejectPO,
    closeNewPODialog,
  };
};
